import React from 'react'
import PropType from 'prop-types'
import Lib from '../../loader'

function Button({
  children,
  className,
  disabled,
  fullWidth,
  onClick,
  variant,
  type,
}) {
  return (
    <Lib.Button
      className={className}
      disabled={disabled}
      fullWidth={fullWidth}
      onClick={onClick}
      variant={variant}
      type={type}
    >
      { children }
    </Lib.Button>
  )
}

Button.defaultProps = {
  children: null,
  className: '',
  disabled: false,
  fullWidth: false,
  onClick: () => null,
  type: 'button',
  variant: 'default',
}

Button.propTypes = {
  children: PropType.node,
  className: PropType.string,
  disabled: PropType.bool,
  fullWidth: PropType.bool,
  onClick: PropType.func,
  type: PropType.string,
  variant: PropType.oneOf(
    ['default', 'plain', 'outlined', 'fab', 'extended', 'icon'],
  ),
}

export default Button
